import React from 'react';
import FlatList from '../../../Base/Components/FlatList';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import LaboratoryResultsListItem from './LaboratoryResultsListItem';
import { LaboratoryResultResult } from '../../../../graphql/graphql';

interface Props {
	flatData: any[];
	onLoadMore: () => void;
	onRefresh: () => void;
	isLoading: boolean;
	hasMoreData: boolean;
	isAllSelected: boolean;
	onItemSelect: (item: LaboratoryResultResult, add: boolean) => void;
}

const WRAPPER_ID = 'laboratoryResultsList';

const LaboratoryResultsList: React.FC<Props> = ({
	flatData,
	onLoadMore,
	onRefresh,
	isLoading,
	hasMoreData,
	isAllSelected,
	onItemSelect,
}) => {
	return (
		<ScrollContainer wrapperId={WRAPPER_ID}>
			<FlatList
				onRefresh={onRefresh}
				onLoadMore={onLoadMore}
				data={flatData}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				scrollableTargetId={WRAPPER_ID}
				itemKey={'id'}
				renderItem={item => (
					<LaboratoryResultsListItem
						item={item}
						onSelect={onItemSelect}
						isSelected={isAllSelected}
						onUnseen={onRefresh}
					/>
				)}
			/>
		</ScrollContainer>
	);
};

export default LaboratoryResultsList;
